import { BaseEntity } from "yt-ng-framework";

export class OsobaEmail extends BaseEntity{
    constructor(){
        super();
    }

    OsobaID: number = null;
    Naziv:string = null;
    SvojinaID:number = null;
    Glavni:boolean = null;
    Opis: string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.OsobaID=input.OsobaID;
        this.Naziv=input.Naziv;
        this.SvojinaID=input.SvojinaID;
        this.Glavni=input.Glavni;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:OsobaEmail){
        return input;
    }
}